export default "ALTER TABLE `pending_notifications` ADD `issuer_hint` text;";